import * as Yup from "yup";

// Character costs for different media types (based on platform best practices)
const MEDIA_CHARACTER_COSTS = {
  image: 50,      // Images: 50 characters each
  video: 100,     // Videos: 100 characters each (heavier content)
  pdf: 75,        // PDFs: 75 characters each
  audio: 60,      // Audio: 60 characters each
};

// Helper function to calculate total character count including media
const calculateTotalCharacterCount = (textCount: number, mediaContent: any) => {
  if (!mediaContent || !mediaContent.content) return textCount;

  let mediaCount = 0;

  // Recursive function to traverse the document tree
  const countMediaNodes = (nodes: any[]) => {
    nodes.forEach(node => {
      if (node.type === 'image') {
        mediaCount += MEDIA_CHARACTER_COSTS.image;
      } else if (node.type === 'video') {
        mediaCount += MEDIA_CHARACTER_COSTS.video;
      } else if (node.type === 'pdf') {
        mediaCount += MEDIA_CHARACTER_COSTS.pdf;
      } else if (node.type === 'audio') {
        mediaCount += MEDIA_CHARACTER_COSTS.audio;
      }

      // Recursively check child nodes
      if (node.content) {
        countMediaNodes(node.content);
      }
    });
  };

  countMediaNodes(mediaContent.content);
  return textCount + mediaCount;
};

// Helper function to get media count breakdown
export const getMediaBreakdown = (mediaContent: any) => {
  if (!mediaContent || !mediaContent.content) return { images: 0, videos: 0, pdfs: 0, audios: 0 };

  let breakdown = { images: 0, videos: 0, pdfs: 0, audios: 0 };

  const countMediaNodes = (nodes: any[]) => {
    nodes.forEach(node => {
      if (node.type === 'image') breakdown.images++;
      else if (node.type === 'customVideo') breakdown.videos++;
      else if (node.type === 'customPdf') breakdown.pdfs++;
      else if (node.type === 'customAudio') breakdown.audios++;

      if (node.content) {
        countMediaNodes(node.content);
      }
    });
  };

  countMediaNodes(mediaContent.content);
  return breakdown;
};

// Function to validate character limit with parameters
export const validateCharacterLimitWithContext = function (this: any, value: string | null | undefined, maxCharacters: number) {
  if (!value) return true; // Let required validation handle empty values

  try {
    const parsed = JSON.parse(value);
    if (parsed?.jsonStr) {
      const jsonContent = JSON.parse(parsed.jsonStr);
      const textCount = parsed.textStr?.length || 0;
      const totalCharacterCount = calculateTotalCharacterCount(textCount, jsonContent);

      if (totalCharacterCount > maxCharacters) {
        const mediaBreakdown = getMediaBreakdown(jsonContent);
        const mediaText = mediaBreakdown.images > 0 || mediaBreakdown.videos > 0 || mediaBreakdown.pdfs > 0 || mediaBreakdown.audios > 0
          ? ` (incluyendo ${mediaBreakdown.images} imágenes, ${mediaBreakdown.videos} videos, ${mediaBreakdown.pdfs} PDFs, ${mediaBreakdown.audios} audios)`
          : '';

        return this.createError({
          message: `No puedes usar más de ${maxCharacters} caracteres. Actual: ${totalCharacterCount}${mediaText}`
        });
      }
    }
  } catch (e) {
    // If parsing fails, let it pass (might be plain text)
    console.warn("Error parsing content for validation:", e);
    return true;
  }

  return true;
};
